import { httpClient, IHttpClient } from '@api'
import { TTopupResponse } from '@api/types'
import { getUserId } from '@stores'

import { TAddress } from '../types/TAddress'
import { TExchangesRes } from '../types/TExchange'
import { TFullName } from '../types/TFullName'
import { TPaymentReceiverInfoResponse } from '../types/TPaymentReceiverInfoResponse'

interface ITopupApplicationClient {
  topup(
    applicationId: string,
    amountFrom: string,
    amountTo: string,
    paymentGatewayId: string,
    sender?: string,
    senderFullName?: TFullName,
    phone?: string,
    last4pan?: string,
  ): Promise<TTopupResponse>

  paymentReceiver(
    paymentPublicId: string,
  ): Promise<TPaymentReceiverInfoResponse>

  confirmPayment(invoiceId: number): Promise<void>

  reject(publicPaymentId: string): Promise<void>

  getExchanges(): Promise<TExchangesRes>

  getUSDTAddress(): Promise<TAddress>
}

const topupApplicationClientFactory = (
  client: IHttpClient,
): ITopupApplicationClient => {
  return {
    topup(
      applicationId: string,
      amountFrom: string,
      amountTo: string,
      paymentGatewayId: string,
      sender?: string,
      senderFullName?: TFullName,
      phone?: string,
      last4pan?: string,
    ): Promise<TTopupResponse> {
      return client.post(
        `/client/v1/topup-applications/${applicationId}/topup`,
        {
          sender: sender,
          senderInfo: senderFullName,
          phone: phone,
          last4pan: last4pan,
          amountFrom: {
            amount: amountFrom,
          },
          amountTo: {
            amount: amountTo,
          },
          paymentGatewayId: paymentGatewayId,
        },
      )
    },
    paymentReceiver(
      paymentPublicId: string,
    ): Promise<TPaymentReceiverInfoResponse> {
      return client.get(
        `/client/v1/topup-applications/payments/${paymentPublicId}/receiver`,
      )
    },
    confirmPayment(invoiceId: number): Promise<void> {
      return client.post(
        `/client/v1/topup-applications/invoices/${invoiceId}/confirm-payment`,
      )
    },
    reject(publicPaymentId: string): Promise<void> {
      return client.post(
        `/client/v1/topup-applications/payments/${publicPaymentId}/reject`,
      )
    },
    getExchanges() {
      return client.get(`/client/v1/exchanges`)
    },
    getUSDTAddress() {
      return client.get(
        `/client/v1/users/${getUserId()}/address?currency=USDT_TRC20`,
      )
    },
  }
}

export const topupApplicationClient: ITopupApplicationClient =
  topupApplicationClientFactory(httpClient)
